<template>
    <grid ref="grid" :isSearch="false" :columnDefs="columnDefs" :fetchCallback="fetchCallback">
        <responsive-button variant="primary" @click="$bvModal.show('compose-modal-id')" :icon="['fas', 'envelope']"
            >Compose</responsive-button
        >
        <responsive-button variant="primary" @click="$bvModal.show('notification-modal-id')" :icon="['fas', 'bell']"
            >Notification</responsive-button
        >
        <send-email-modal @emailSent="refresh()" />
        <send-notification-modal @notificationSent="refresh()" />
    </grid>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import api from '../../../../api';
import { ADMIN_SUBSCRIBER_COMMUNICATION } from '../../../../endpoints';
import grid from '../../../generic/grid/grid.vue';
import { mapGetters } from 'vuex';
import ActionsCellRenderer from './actions-cell-renderer.vue';
import Modal from '../../../generic/modal/modal.vue';
import ResponsiveButton from '../../../generic/responsive-button/responsive-button.vue';
import SendEmailModal from './send-email-modal.vue';
import SendNotificationModal from './send-notification-modal.vue';
export default {
    components: {
        grid,
        Modal,
        ResponsiveButton,
        SendEmailModal,
        SendNotificationModal,
        actionsCellRenderer: ActionsCellRenderer,
    },
    data() {
        return {
            offset: 0,
            limit: 20,
            sort: 'date',
            desc: true,
            search: '',
            modalId: 'compose-modal',
        };
    },
    inject: ['userId'],
    computed: {
        ...mapGetters('header', ['userUnicodeDateFormat']),
        ...mapGetters('adminSubscriberAccount', ['details']),
        columnDefs() {
            return [
                {
                    field: 'date',
                    headerName: 'Date',
                    cellRenderer: ({ data }) =>
                        data &&
                        data.date &&
                        format(
                            parseISO(data.date),
                            `${this.userUnicodeDateFormat} hh:mm:ss`
                        ),
                    minWidth: 190,
                    maxWidth: 190,
                    sort: 'desc',
                },
                {
                    field: 'msg_type',
                    headerName: 'Type',
                    cellRenderer: ({ data }) => {
                        if(data.msg_type === 1){
                            return 'Notification'
                        }
                        else if(data.msg_type === 2) {
                            return 'SMS'
                        }
                        else {
                            return 'Email' 
                        }
                    },         
                    minWidth: 120,
                    maxWidth: 120,
                },                
                {
                    field: 'subject',
                    headerName: 'Message',
                    minWidth: 250,
                    cellRenderer: ({ data }) => {
                        if (data) {
                            return `${data.subject} ${
                                data.attachment1 || data.attachment2
                                    ? '-' +
                                      data.attachment1 +
                                      ' ' +
                                      data.attachment2
                                    : ''
                            }`;
                        }
                    },
                },
                {
                    field: '',
                    cellRenderer: 'actionsCellRenderer',
                    minWidth: 140,
                    maxWidth: 140,
                },
            ];
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return api.get(
                    `${ADMIN_SUBSCRIBER_COMMUNICATION(
                        this.userId
                    )}communication/`,
                    {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
        methods: {
            refresh() {
                this.$refs.grid.refreshDataSource();
            },
        },
    };
</script>
